import 'react-app-polyfill/stable'

import React from 'react'
import { createRoot } from 'react-dom/client'

import 'chart.js/auto'
import 'animate.css/animate.min.css'

import App from './App'
import reportWebVitals from './utils/reportWebVitals'
import { ThemeProvider } from './contexts/ThemeContext'

import { LicenseInfo } from '@mui/x-license'

// This is the license key for the @mui/x-license package (grid and datepicker components).
LicenseInfo.setLicenseKey(
    '2bfd9bf1f3ca50536712255b785ceb72Tz0xMTc2NjYsRT0xNzg3MzU2Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
)

// Note: Remove the following line if you want to disable the API mocks.
// import "./mocks";

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
    <ThemeProvider>
        <App />
    </ThemeProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
